<section class="container">
  <span
    data-cy="selection-banner-warning-message"
    class="warning-message show-small-devices"
    *ngIf="!!warningMessage"
    ><ion-icon name="alert-circle-outline"></ion-icon> {{ warningMessage }}
  </span>
  <div class="content">
    <div class="right">
      <div class="items-count">
        <div *ngIf="countItemsSelected !== 1">
          {{
            'i18n.payments.itemsSelected'
              | translate: { itemsSelected: countItemsSelected }
          }}
        </div>
        <div *ngIf="countItemsSelected === 1">
          {{
            'i18n.payments.itemSelected'
              | translate: { itemsSelected: countItemsSelected }
          }}
        </div>
      </div>
      <ng-container>
        <div class="separator" src="assets/images/divider-white.svg"></div>
        <ion-button
          data-cy="selection-banner-select-all-button"
          (click)="onSelectAllClick()"
        >
          {{ 'i18n.common.selectAll' | translate }}
        </ion-button>
        <div class="separator" src="assets/images/divider-white.svg"></div>
        <ion-button
          data-cy="selection-banner-deselect-all-button"
          (click)="onDeselectAllClick()"
        >
          {{ 'i18n.common.deselectAll' | translate }}
        </ion-button>
      </ng-container>
    </div>
    <div class="banner-gap">
      <ion-button
        *ngIf="isDownloadEnabled"
        class="download-button"
        data-cy="selection-banner-download-button"
        (click)="onDownloadClick()"
      >
        {{ 'i18n.common.download' | translate }}
      </ion-button>
      <span
        data-cy="selection-banner-warning-message"
        class="warning-message show-big-devices"
        *ngIf="!!warningMessage"
        ><ion-icon name="alert-circle-outline"></ion-icon> {{ warningMessage }}
      </span>
    </div>
    <ion-button
      *ngIf="showMainAction"
      class="pay-button usf-fill-white-button"
      data-cy="selection-banner-pay-button"
      (click)="onMainActionClick()"
    >
      {{ labelMainActionBtn }}
    </ion-button>
  </div>
</section>
